import { Modal, ModalFooter, Spinner } from "react-bootstrap";
import { CompanyProfile } from "../../../../pages/leads-management/models/ICompanyProfile";
import { CheckIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/CheckIcon";
import { InfoIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/InfoIcon";
import { WebsiteIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/WebsiteIcon";
import { WebsiteShareIcon } from "../../../../styles/icons/IconFiles/CommonIcons/WebsiteShareIcon";
import { LocationIcon } from "../../../../styles/icons/IconFiles/CommonIcons/LocationIcon";
import { IndustryIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/IndustryIcon";
import { PhoneIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/PhoneIcon";
import { StarWithoutColorIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/StarWithoutColorIcon";
import { StarWithColorIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/StarwithColorIcon";
import { TargetIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/TargetIcon";
import { CompanyIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/CompanyIcon";
import { AIIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/AIIcon";
import { ArrowIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/ArrowIcon";
import LinkedIn from "../../../../styles/icons/IconFiles/CommonIcons/SocialMediaSVGS/LinkedIn";
import { LinkedInIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/LinkedInIcon";
import { FacebookIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/FacebookIcon";
import { InstergramIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/InstergramIcon";
import { YoutubeIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/YoutubeIcon";
import { ChromeIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/ChromeIcon";
import { CheckWithCirculeIcon } from "../../../../styles/icons/IconFiles/LeadsIcons/CheckWithCirculeIcon";
import { InfoShield } from "../../../../styles/icons/IconFiles/LeadsIcons/InfoShield";
import { GoogleIcon } from "../../../../styles/icons/IconFiles/CommonIcons/SocialMediaSVGS/GoogleIcon";
import { GoogleMapIcon } from "../../../../styles/icons/IconFiles/CommonIcons/SocialMediaSVGS/GoogleMapIcon";
import { DocumentIcon } from "../../../../styles/icons/IconFiles/CommonIcons/SocialMediaSVGS/DocumentIcon";
import IconHome from "../../../../styles/icons/IconHome";

interface Props {
  onHide: () => void;
  show: boolean;
  companyProfile: CompanyProfile | null;
  isLoading: boolean;
  companyName: string;
}

const CompanyModal = (props: Props) => {
  if (props.isLoading) {
    return (
      <Modal show={props.show} onHide={props.onHide} size="xl" centered>
        <Modal.Body className="text-center p-5">
          <Spinner animation={"border"} />
        </Modal.Body>
      </Modal>
    );
  }

  if (!props.companyProfile) return null;

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="xl"
      centered
      className="company-modal"
    >
      <Modal.Header closeButton>
        <div className="modal-header-wrapper">
          <div>
            <TargetIcon activeColor="#0f1560" />
          </div>
          <div>
            <h4 className="mb-1">Identity Intelligence</h4>
            <small>
              Verified information and key insights from trusted public sources
            </small>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        {/* Top Company Card */}
        <div className="company-summary-card">
          <div className="company-summary-card-content-header">
            <div className="company-summary-header">
              <div className="company-logo">
                <img
                  src="https://ui-avatars.com/api/?name=Company&background=0D8ABC&color=fff"
                  alt={props.companyProfile?.companyName}
                />
              </div>
              <div className="company-info">
                <h5 className="mb-1">{props.companyProfile?.companyName}</h5>
                <div className="verified-badge">
                  <CheckIcon activeColor="#065f46" />
                  <p>Verified</p>
                </div>
              </div>
            </div>
            <div className="identity-confident">
              <div className="identity-confidence-header">
                <h6 className="mb-1">Identity Confidence</h6>
                <InfoIcon activeColor="#327bf9" />
              </div>
              <h2>{props.companyProfile?.identityConfidence || 0}%</h2>
              <div className="confidence-progress">
                <div
                  className="confidence-progress-fill"
                  style={{
                    width: `${props.companyProfile?.identityConfidence || 0}%`,
                  }}
                />
              </div>
            </div>
          </div>

          <div className="company-details">
            {/* Additional company details can be added here */}
            <div className="company-details-row">
              <div className="company-details-row-header">
                <WebsiteIcon activeColor="#9aa3b2" />
                <h6>Website</h6>
              </div>
              <div className="company-details-row-content">
                <a
                  href={props.companyProfile?.website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {props.companyProfile?.website
                    ? new URL(props.companyProfile.website).hostname
                        .replace(/^https:\/\\./, "")
                        .replace(/^https:\/\//, "")
                    : "N/A"}
                </a>
                <WebsiteShareIcon activeColor="#327bf9" />
              </div>
            </div>
            <div className="company-details-row">
              <div className="company-details-row-header">
                <LocationIcon activeColor="#9aa3b2" />
                <h6>Address</h6>
              </div>
              <div className="company-details-row-content">
                <p>{props.companyProfile?.location || "N/A"}</p>
              </div>
            </div>
            <div className="company-details-row">
              <div className="company-details-row-header">
                <IndustryIcon activeColor="#9aa3b2" />
                <h6>Industry</h6>
              </div>
              <div className="company-details-row-content">
                <p>{props.companyProfile?.industry || "N/A"}</p>
              </div>
            </div>
            <div className="company-details-row">
              <div className="company-details-row-header">
                <PhoneIcon activeColor="#9aa3b2" />
                <h6>Phone</h6>
              </div>
              <div className="company-details-row-content">
                <p>{props.companyProfile?.phoneNumber || "N/A"}</p>
              </div>
            </div>
            <div className="company-details-row">
              <div className="company-details-row-header">
                <StarWithoutColorIcon activeColor="#9aa3b2" />
                <h6>Google Rating</h6>
              </div>
              <div className="company-details-row-content">
                <div className="rating-display-wrapper">
                  <div className="rating-display">
                    <StarWithColorIcon activeColor="#e4d00a" />
                    <p>{props.companyProfile?.rating || 0}</p>
                  </div>
                  <p className="review-count">
                    ({props.companyProfile?.reviewCount || 0} reviews)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="company-details-grid">
          <div className="company-details-card">
            <div className="company-details-card-header">
              <CompanyIcon activeColor="#4f46e5" />
              <h5>Company Overview</h5>
            </div>
            <p>{props.companyProfile?.description || "N/A"}</p>
            <div
              className="view-more-link"
              onClick={() =>
                window.open(props.companyProfile?.googleMapsUrl, "_blank")
              }
            >
              <a
                href={props.companyProfile.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                View more
              </a>
              <ArrowIcon activeColor="#4f46e5" />
            </div>
          </div>
          <div className="company-details-card">
            <div className="company-details-card-header">
              <div className="icon-wrapper">
                <WebsiteIcon activeColor="#4f46e5" />
              </div>
              <h5>Online Presence</h5>
            </div>
            <div className="online-presence-list">
              <div className="online-presence-item">
                <div className="icon-link-wrapper">
                  <WebsiteIcon activeColor="#9aa3b2" />
                  <a
                    href={props.companyProfile?.website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Website
                  </a>
                </div>
                <CheckWithCirculeIcon activeColor="#065f46" />
              </div>
              {props.companyProfile?.socialMedia?.linkedIn && (
                <div className="online-presence-item">
                  <div className="icon-link-wrapper">
                    <LinkedInIcon activeColor="#9aa3b2" />
                    <a
                      href={props.companyProfile?.socialMedia?.linkedIn}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </div>
                  <CheckWithCirculeIcon activeColor="#065f46" />
                </div>
              )}
              {props.companyProfile?.socialMedia?.facebook && (
                <div className="online-presence-item">
                  <div className="icon-link-wrapper">
                    <FacebookIcon activeColor="#9aa3b2" />
                    <a
                      href={props.companyProfile?.socialMedia?.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                  </div>
                  <CheckWithCirculeIcon activeColor="#065f46" />
                </div>
              )}
              {props.companyProfile?.socialMedia?.instagram && (
                <div className="online-presence-item">
                  <div className="icon-link-wrapper">
                    <InstergramIcon activeColor="#9aa3b2" />
                    <a
                      href={props.companyProfile?.socialMedia?.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Instagram
                    </a>
                  </div>
                  <CheckWithCirculeIcon activeColor="#065f46" />
                </div>
              )}
              {props.companyProfile?.socialMedia?.youtube && (
                <div className="online-presence-item">
                  <div className="icon-link-wrapper">
                    <YoutubeIcon activeColor="#9aa3b2" />
                    <a
                      href={props.companyProfile?.socialMedia?.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Youtube
                    </a>
                  </div>
                  <CheckWithCirculeIcon activeColor="#065f46" />
                </div>
              )}
              {props.companyProfile?.googleMapsUrl && (
                <div className="online-presence-item">
                  <div className="icon-link-wrapper">
                    <ChromeIcon activeColor="#9aa3b2" />
                    <a
                      href={props.companyProfile?.googleMapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Google Business Profile
                    </a>
                  </div>
                  <CheckWithCirculeIcon activeColor="#065f46" />
                </div>
              )}
            </div>
            <div
              className="view-more-link"
              onClick={() =>
                window.open(props.companyProfile?.googleMapsUrl, "_blank")
              }
            >
              <a
                href={props.companyProfile.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                View more
              </a>
              <ArrowIcon activeColor="#4f46e5" />
            </div>
          </div>
          <div className="company-details-card">
            <div className="company-details-card-header">
              <div className="icon-wrapper">
                <LocationIcon activeColor="#4f46e5" />
              </div>
              <h5>Location</h5>
            </div>
            <iframe
              width="100%"
              height="180"
              style={{ border: 0, borderRadius: "8px" }}
              loading="lazy"
              allowFullScreen
              src={`https://www.google.com/maps?q=${props.companyProfile?.latitude},${props.companyProfile?.longitude}&z=15&output=embed`}
            />
            <div
              className="view-google-link"
              onClick={() =>
                window.open(props.companyProfile?.googleMapsUrl, "_blank")
              }
            >
              <a
                href={props.companyProfile?.googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Google Maps
              </a>
              <WebsiteShareIcon activeColor="#327bf9" />
            </div>
          </div>
          <div className="company-details-card">
            <div className="company-details-card-header">
              <div className="icon-wrapper">
                <StarWithoutColorIcon activeColor="#4f46e5" />
              </div>
              <h5>Reputation</h5>
            </div>
            <div className="rating-section">
              <span className="rating-label">Google Rating</span>

              <div className="rating-row">
                <h2>{props.companyProfile?.rating || 0}</h2>

                <div className="stars">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      style={{
                        color:
                          (props.companyProfile?.rating || 0) === 0
                            ? "#d1d5db" // Gray when rating is 0
                            : "#fbbf24", // Yellow otherwise
                      }}
                    >
                      ★
                    </span>
                  ))}
                </div>

                <span className="review-count">
                  ({props.companyProfile?.reviewCount || 0} reviews)
                </span>
              </div>
              <div className="review-link">
                <a
                  href={props.companyProfile?.googleMapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View reviews
                </a>

                <ArrowIcon activeColor="#4f46e5" />
              </div>
            </div>
          </div>
          <div className="company-details-card ai-summary-card">
            <div className="company-details-card-header">
                <IconHome breadcrumb="logoWithoutText" />
              <h5>Erniee Summary</h5>
            </div>
            <p>
              {props.companyProfile?.aiSummaryDescription ||
                "No AI summary available."}
            </p>
          </div>
        </div>

        <div className="company-meta-card">
          {/* Data Sources */}
          <div className="meta-section">
            <h6>Data Sources</h6>

            <div className="source-icons">
              <GoogleIcon />
              <LinkedIn />
              <GoogleMapIcon />
              <DocumentIcon />
            </div>
          </div>

          {/* Info */}
          <div className="meta-section info-section">
            <div className="info-content">
              <InfoShield activeColor="#2563eb" />

              <p>
                Information is aggregated from publicly available sources and
                may not always be up to date.
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CompanyModal;
